import { palette } from '../global/palette';
import { typography } from '../global/typography';
export const MuiBreadcrumbs = {
    MuiBreadcrumbs: {
        styleOverrides: {
            li: {
                '& p': Object.assign({}, typography.body2),
                '& a': Object.assign(Object.assign({}, typography.body2), { color: palette.grey[500], '&:visited, &:hover, &:focus, &:active': {
                        color: palette.grey[500],
                    } }),
            },
            separator: {
                marginLeft: 12,
                marginRight: 12,
                color: palette.grey[500],
            },
        },
    },
};
